module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_01_1280_1280_ja-d6eebe878545b908a426b22880eaa938.jpg";